import React, {useEffect, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {add, listColorTypes, listSportsHall} from '../../../lib/api/club';
import {listForeigner, listGender, listPosition} from "../../../lib/api/player";
import {list} from "../../../lib/api/federation";

export function Add({ onClose, onSave }) {
  const [sportsHall, setSportsHall] = useState([]);
  const [colorTypes, setColorTypes] = useState([]);
  const [selectedColors, setSelectedColors] = useState({
    home_color_type_id: '',
    away_color_type_id: ''
  });

  const getColorValue = color => (color ? color.toLowerCase() : '');
  const getColorTypeById = colorTypeId =>
    colorTypes.find(p => String(p.color_types_id) === String(colorTypeId));

  const [errors, setErrors] = useState({
    name: false,
    short_name: false,
    place: false,
    sports_hall_id: false,
    federation_entities_id: false,
    home_color_type_id: false,
    away_color_type_id: false
  });

  useEffect(() => {
    (async () => {
      const resSportsHall = await listSportsHall();
      const resColorTypes = await listColorTypes();
      setSportsHall(resSportsHall);
      setColorTypes(resColorTypes);
    })();
  }, []);

  const handleColorChange = event => {
    const { name, value } = event.target;
    setSelectedColors(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!validateForm(event)) return;

    const _data = {
      name: form.name.value,
      short_name: form.short_name.value,
      place:  form.place.value,
      sports_hall_id: form.sports_hall_id.value,
      federation_entities_id: form.federation_entities_id.value,
      home_color_type_id: form.home_color_type_id.value,
      away_color_type_id: form.away_color_type_id.value,
      image: form.image.files[0]
    };

    await add(_data);
    onSave();
    onClose();
  };

  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      name: !form.name.value.trim(),
      short_name: !form.short_name.value.trim(),
      place: !form.place.value.trim(),
      sports_hall_id: !form.sports_hall_id.value.trim(),
      federation_entities_id: !form.federation_entities_id.value,
      home_color_type_id: !form.home_color_type_id.value,
      away_color_type_id: !form.away_color_type_id.value
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };

  return (
    <Card>
      <Card.Body className="bg-body-tertiary">
        <Form
          method="POST"
          encType="multipart/form-data"
          noValidate
          onSubmit={handleSubmit}
        >
          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="name">
              <Form.Label>Naziv kluba</Form.Label>
              <Form.Control
                required
                type="text"
                name="name"
                isInvalid={errors.name}
              />
              <Form.Control.Feedback type="invalid">
                Molimo unesite naziv kluba.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="short_name">
              <Form.Label>Skraćeni naziv</Form.Label>
              <Form.Control
                required
                type="text"
                name="short_name"
                isInvalid={errors.short_name}
              />
              <Form.Control.Feedback type="invalid">
                Molimo unesite skraćeni naziv.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group controlId="image">
              <Form.Label>Izaberi logo</Form.Label>
              <Form.Control type="file" name="image" />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="place">
              <Form.Label>Mjesto</Form.Label>
              <Form.Control
                required
                type="text"
                name="place"
                isInvalid={errors.place}
              />
              <Form.Control.Feedback type="invalid">
                Molimo unesite mjesto.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="8" controlId="sports_hall_id">
              <Form.Label>Hala</Form.Label>
              <Form.Select
                  name="sports_hall_id"
                  required
                  isInvalid={errors.sports_hall_id}
              >
                <option value="">Izaberi</option>
                {sportsHall.map(p => (
                    <option key={p.sports_hall_id} value={p.sports_hall_id}>
                      {p.name}
                    </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="home_color_type_id">
              <Form.Label className="d-flex align-items-center gap-2">
                Dres kao domaćin
                <span
                  style={{
                    display: 'inline-block',
                    width: '14px',
                    height: '14px',
                    borderRadius: '3px',
                    border: '1px solid #ced4da',
                    backgroundColor: getColorValue(getColorTypeById(selectedColors.home_color_type_id)?.background_color) || 'transparent'
                  }}
                />
              </Form.Label>
              <Form.Select
                  name="home_color_type_id"
                  required
                  isInvalid={errors.home_color_type_id}
                  onChange={handleColorChange}
              >
                <option value="">Izaberi</option>
                {colorTypes.map(p => (
                    <option key={p.color_types_id} value={p.color_types_id}>
                      {p.background_color}
                    </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="away_color_type_id">
              <Form.Label className="d-flex align-items-center gap-2">
                Dres kao gost
                <span
                  style={{
                    display: 'inline-block',
                    width: '14px',
                    height: '14px',
                    borderRadius: '3px',
                    border: '1px solid #ced4da',
                    backgroundColor: getColorValue(getColorTypeById(selectedColors.away_color_type_id)?.background_color) || 'transparent'
                  }}
                />
              </Form.Label>
              <Form.Select
                  name="away_color_type_id"
                  required
                  isInvalid={errors.away_color_type_id}
                  onChange={handleColorChange}
              >
                <option value="">Izaberi</option>
                {colorTypes.map(p => (
                    <option key={p.color_types_id} value={p.color_types_id}>
                      {p.background_color}
                    </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="federation_entities_id">
              <Form.Label>Savez</Form.Label>
              <Form.Select
                name="federation_entities_id"
                required
                isInvalid={errors.federation_entities_id}
              >
                <option value="">Izaberi</option>
                <option value="1721">Crna Gora</option>
              </Form.Select>
            </Form.Group>
          </Row>
          <Button type="submit">Sačuvaj</Button>
        </Form>
      </Card.Body>
    </Card>
  );
}
